import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import axios from 'axios';
import NotificationPopUp from './NotificationPopUp';
import "react-big-calendar/lib/css/react-big-calendar.css";

moment.locale("en-GB");
const localizer = momentLocalizer(moment);

export default class ReactBigCalendar extends Component 
{
constructor(props) 
	  {
			super();
			
			this.state = {eventsData:[],popuptype:"1",noid:0,celldate:'',edate:''}
			  this.updateDonenewParent = this.updateDonenewParent;
	  }
	  		
 handleSelect=(date)=>{
	console.log(date);
 var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
  date1=date.getFullYear()+"-"+month+"-"+date1
	 this.setState({ noid: 0 ,celldate:date1,edate:date});  
 /*   const title = window.prompt("New Event name");

     const updatedArray = [...this.state.eventsData];
	 updatedArray.title=title;
	 	 updatedArray.start=start;
		 updatedArray.end=end;
	 this.setState({eventsData:updatedArray});*/
	  setTimeout(() => this.refs.NotificationPopUp.handleClickOpen(),500);
 }
  handleNotification=(start,noid)=>{
	
	   this.setState({ noid: noid },()=>{this.refs.NotificationPopUp.handleClickOpen()});  
	
	  
  }
  updateDonenewParent = (text) => { this.NotificationAPIcall();  }
 componentWillMount() {
	 	document.title = "AthaYog Living - Notifications";
	
	
if(localStorage.getItem("AYLuserid")==null)
		 {

		   this.setState({
            logredirect: true,
			pagename:'/Default'
          })
		  }
	 this.NotificationAPIcall();
	 
 }
NotificationAPIcall()
{
axios.get(Serverurl+'ajaxnotifications.php?action=getall')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({eventsData:resp.data});
			}
	   });
}

customDayPropGetter = (date) => {

  let data = this.state.eventsData
  
   var month="",date1="";
	
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}
	 
	 
	  if((date.getDate() )<10)
	 {
		date1="0"+ (date.getDate() )		 
	 }else{date1=(date.getDate())}
  
  date=date1+"/"+month+"/"+date.getFullYear()
   var obj = data.find((item, index) => {
	  
	   
	   
	   
	     if ((item.nodate === date && item.title !== "")  )
		 {
			 
			   return data[index]
		 }
   });
  
    if(obj !== undefined && obj.nodate === date &&  obj.title !== "")
	{
	 
        return { style: { backgroundColor: "#2588f5", Color:'#fff' } }
	}
    
        else {return { style: { backgroundColor: "#fff", Color:'#fff' } }}
   
	/*return {
	  style: {
		backgroundColor: '#fff', //this works
		color: '#ffffff' //but why doesn't this work?
	  }
	}*/
}

 eventStyleGetter=(event,start, end,isSelected)=>{

    console.log(event);
    var backgroundColor = '#2588f5' ;
    var style = {
        backgroundColor: backgroundColor,
        borderRadius: '0px',
        opacity: 0.8,
        color: '#fff',
        border: '0px',
        display: 'block',
		textalign:'Center',
    };
    return {
        style: style
    };
}
render() {
  return (
  <React.Fragment>
   <div className="mainheading"><h1> Notifications</h1></div>

<div className="clear"></div>
	
	<div className="contntpad">
	
	<NotificationPopUp ref="NotificationPopUp" id={this.state.noid} celldate={this.state.celldate} edate={this.state.edate}  updateDonenew={this.updateDonenewParent}/>


      <Calendar
        views={["month"]}
        selectable
        localizer={localizer}
        defaultDate={new Date()}
        defaultView="month"
		dayPropGetter={this.customDayPropGetter }
        events={this.state.eventsData}
        style={{ height: "140vh" }}
        onSelectEvent={(event) => this.handleNotification(event.start,event.id)}
		 eventPropGetter={(this.eventStyleGetter)}
        onSelectSlot={(event)=>this.handleSelect(event.start)}
      /> 
    </div>
	</React.Fragment>
  );
}
}
